export enum FormLiveStateType {
  DEFAULT = 0,
  LOADING = 1,
  OK = 2,
  ERROR = 3
}
